/* eslint-disable react/display-name */
import { Button } from 'antd'
import { CalendarMode } from 'antd/lib/calendar/generateCalendar'
import Modal from 'antd/lib/modal/Modal'
import Paragraph from 'antd/lib/typography/Paragraph'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Table } from '../../../../core/components'
import { routesConfig } from '../../../../core/configs/routes'
import { dateTimeFormat } from '../../../../utils/format/dateTimeFormat'
import { phoneNumberFormat } from '../../../../utils/format/phoneNumberFormat'
import { useCalendarContext } from '../CalendarPage.context'

const title = (mode: CalendarMode, date: any) => {
  if (mode === 'month') {
    return `Contatos do dia ${dayjs(date).format('DD/MM/YYYY')}`
  } else return `Contatos do mês ${dayjs(date).format('MM/YYYY')}`
}

export const CalendarDetails: React.FC = () => {
  const { selected, setSelected, mode } = useCalendarContext()
  const [pagination, setPagination] = useState<{ page: number; limit: number }>(
    { page: 1, limit: 5 }
  )
  const footer = () => {
    return (
      <Button key="close" onClick={() => setSelected('')}>
        Fechar
      </Button>
    )
  }

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const columns = [
    {
      title: 'N° Op',
      dataIndex: 'opportunityId',
      key: 'opportunityId',
      render: (value: any) => {
        return (
          <Link
            to={
              routesConfig.oportunities.oportunity.details +
              `/${value}/detalhes`
            }
          >
            <Button type="link">{value}</Button>
          </Link>
        )
      }
    },
    {
      title: 'Nome Cliente',
      dataIndex: 'customer',
      key: 'customer',
      render: (value: any) => {
        return (
          <Paragraph ellipsis={value ? { rows: 2 } : false}>
            {value.name}
          </Paragraph>
        )
      }
    },
    {
      title: 'Situação',
      dataIndex: 'situation',
      key: 'situation'
    },
    {
      title: 'Telefone',
      dataIndex: 'customer',
      key: 'customer',
      render: (value: any) => {
        return phoneNumberFormat(value.fone)
      }
    },
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
      render: (value: any) => {
        return dateTimeFormat(value)
      }
    }
  ]

  return (
    <Modal
      title={title(mode, selected?.[0]?.date)}
      onCancel={() => setSelected('')}
      visible={!!selected}
      centered
      width={1000}
      footer={[footer()]}
    >
      <Table
        dataSource={selected?.map((data) => data)}
        columns={columns}
        bordered
        pagination={{
          pageSize: pagination.limit,
          current: pagination.page,
          onChange: (page, limit) => handlePagination(page, limit || 10)
        }}
      />
    </Modal>
  )
}
